export function getCopyright() {
    let copyrightTitle = "";
    switch (process.env.VUE_APP_PLATFORM) {
        case "Equal":
            copyrightTitle = "EQUAL FINANCE";
            break;
        case "Autentic stage":
            copyrightTitle = "Autentic Ltd. | All rights reserved.";
            break;
        case "Autentic":
            copyrightTitle = "Autentic Ltd. | All rights reserved.";
            break;
        case "RWA.Capital":
            copyrightTitle = "RWA.Capital";
            break;
        default:
            break;
    }
    return `@ ${new Date().getFullYear()} ${copyrightTitle}`;
}
